<template>
  <div class="recharge-page">
    <div class="recharge-container" v-loading="loading">
      <!--
      <div class="item-list" style="color:#e50406;">周年庆期间，充值即额外赠送10%的积分（添加客户经理领取积分）</div>
      -->
      <div class="item-list">
        <div class="left-label">账户ID</div>
        <div class="right-content">
          <div class="right-item font date">
            {{ user.userId }}
            <span v-if="user.memberExpireDate && user.memberStatus !== 3" class="cursor-style color-red">
              （{{ user.memberExpireDate }}会员到期）
            </span>
            <span v-if="user.memberStatus === 3" class="cursor-style color-red">您的会员已到期</span>
          </div>
        </div>
      </div>
      <div class="item-list">
        <div class="left-label">余额</div>
        <div class="right-content">
          <div class="right-item red font">{{ user.coinNum || 0 }}积分</div>
        </div>
      </div>
      <div class="item-list">
        <div class="left-label">积分使用规则</div>
        <div class="right-content">
          <div class="right-item font ">1积分等于1次查询</div>
        </div>
      </div>
      <div class="item-list item-list-felx">
        <div class="left-label">积分套餐</div>
        <div class="right-content">
          <div class="integral w700 flex-wrap">
            <div class="right-item" :key="index" v-for="(item, index) in dynamicTags">
              <div :class="[
                'gold-tag',
                goldIndex == index ? 'gold-tag-active' : '',
              ]" @click="tapTag(item, index)">
                <div>{{ item.coinNum }}积分</div>
                <!-- <div>送{{ item.giftCoinNum }}积分</div> -->
              </div>
            </div>
          </div>
          <div class="give-welfare" v-if="selectItem.firstGiftSearchDesc || selectItem.searchFreeNum">
            <!-- <div
              :class="[
                'left-give',
                user.recharged ? '' : 'the-first',
                giveIndex === 0 ? 'active-give' : '',
              ]"
              @click="handleGiveIndex(0)"
            >
              <i class="active-bottom" v-if="giveIndex === 0"></i>
              {{ selectItem.firstGiftMemberDesc }}
            </div> -->
            <div :class="[
              'right-give',
              user.recharged ? '' : 'the-first',
              giveIndex === 1 ? 'active-give' : '',
            ]" @click="handleGiveIndex(1)">
              <i class="active-bottom" v-if="giveIndex === 1"></i>
              {{ selectItem.firstGiftSearchDesc || `送${selectItem.searchFreeNum}次免费查询` }}
            </div>
          </div>
        </div>
      </div>
      <div class="item-list">
        <div class="left-label center">支付方式</div>
        <div class="right-content">
          <div class="right-item">
            <div class="kx-button w200" :class="payIndex == 1 ? 'active' : ''" @click="tapPay(1)">
              <div class="flex-center-wrap">
                <i class="icon-wchat-pay"></i>
                <span class="pl8 f18 color-2">微信</span>
              </div>
            </div>
            <!-- <img
              src="../../assets/use-account/pay-icon/wx-active.png"
              alt=""
              class="pay-tag"
              v-if="payIndex == 1"
            />
            <img
              src="../../assets/use-account/pay-icon/wx.png"
              class="pay-tag"
              alt=""
              v-else
              @click="tapPay(1)"
            /> -->
          </div>
          <div class="right-item">
            <div class="kx-button w200" :class="payIndex == 0 ? 'active' : ''" @click="tapPay(0)">
              <div class="flex-center-wrap">
                <i class="icon-zfb"></i>
                <span class="pl8 f18 color-2">支付宝</span>
              </div>
            </div>
            <!-- <img
              src="../../assets/use-account/pay-icon/zfb-active.png"
              class="pay-tag"
              alt=""
              v-if="payIndex == 0"
            />
            <img
              src="../../assets/use-account/pay-icon/zfb.png"
              alt=""
              class="pay-tag"
              v-else
              @click="tapPay(0)"
            /> -->
          </div>
          <!-- <div class="right-item">
            <img
              src="../../assets/use-account/pay-icon/Payoneer-active.png"
              class="pay-tag"
              alt=""
              v-if="payIndex == 2"
            />
            <img
              src="../../assets/use-account/pay-icon/Payoneer.png"
              alt=""
              class="pay-tag"
              v-else
              @click="tapPay(2)"
            />
          </div> -->
        </div>
      </div>
      <div class="item-list">
        <div class="left-label">实际到账</div>
        <div class="right-content">
          <div class="right-item">
            <span class="coin">{{ coin }}</span>
          </div>
        </div>
      </div>
      <div class="item-list">
        <div class="left-label">充值金额</div>
        <div class="right-content">
          <div class="right-item">
            <span class="gold-num">￥{{ price
            }}<span class="gold-exchange" v-if="exchangeList.length > 0">{{
    getPrice
}}</span></span>
          </div>
        </div>
      </div>
      <div class="item-list agreement">
        <el-checkbox v-model="checked">我已了解并同意</el-checkbox><span @click="rechargeProtocolDV = true">《充值使用协议》</span>
      </div>
      <div class="footer-btn">
        <el-button @click="tapToUp" v-pointerReClick class="btn">立即充值</el-button>
      </div>
    </div>
    <bind-mobile :bindPhoneDV="bindPhoneDV" @bindPhone="handleBindPhone" />
    <!-- 微信支付 -->
    <el-dialog title="扫码支付" :visible.sync="toUpDV" width="600px" :before-close="closeToUpDv" class="to-up-DV"
      :close-on-click-modal="false">
      <div class="to-up-content">
        <div class="left-code">
          <div class="pay-tip">
            <img src="../../assets/use-account/wx-pay.png" alt="" />
            <span>微信支付</span>
          </div>
          <div class="qrcode" ref="qrCodeUrl" v-if="toUpDV"></div>
          <div class="wx-pay-price">
            <div>
              <span>收款方</span>
              <span>深圳市带塔云科技有限公司</span>
            </div>
            <div>
              <span>商品名称</span>
              <span>{{ shopName }}</span>
            </div>
            <div class="pay-price">
              <span>支付金额</span>
              <span class="price">￥{{ price }}</span>
            </div>
          </div>
        </div>
        <div class="right-tip">
          <img src="../../assets/use-account/wx-pay-tip.png" alt="" />
        </div>
      </div>
    </el-dialog>
    <!-- 支付宝支付 -->
    <el-dialog title="网上支付提示" :visible.sync="zfbDV" width="500px" :before-close="closeZFBDV"
      :close-on-click-modal="false" :show-close="false" class="zfb-DV">
      <template slot="title">
        <div class="zfb-title">网上支付提示</div>
      </template>
      <div class="zfb-content">
        <div class="left-img">
          <i class="el-icon-loading"></i>
        </div>
        <div class="right-tip">
          <div>支付完成前，请不要关闭此支付验证窗口</div>
          <div>支付完成后，请根据您支付的情况点击下面按钮。</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="pay-issue" v-pointerReClick @click="closeZFBDV(1)">重新支付</el-button>
        <el-button class="pay-success" @click="$router.push('/recharge-record')">完成支付</el-button>
      </span>
    </el-dialog>
    <recharge-protocol :rechargeProtocolDV="rechargeProtocolDV" @closeRechargeProtocol="closeRechargeProtocol" />
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import {
  detailList,
  createCoinOrder,
  userInfo,
  paymentStatus,
  queryCoin,
  currentExchange
} from '@/api/user.js'
import bindMobile from '@/components/bind-mobile/index.vue'
import rechargeProtocol from './components/recharge-protocol.vue'
export default {
  name: 'recharge',
  components: {
    bindMobile,
    rechargeProtocol
  },
  props: {},
  data() {
    return {
      user: {},
      dynamicTags: ['50', '100', '200'],
      inputVisible: false,
      inputValue: '',
      isShowAddTab: false,
      price: '',
      goldIndex: 0,
      payIndex: 1,
      payParams: {
        detailCode: '',
        coinNum: 0,
        payMethod: '1',
        firstGift: 'member'
      },
      toUpDV: false,
      qrcode: '',
      qrCodeUrl: '',
      loading: false,
      timeId: '',
      orderNo: '',
      editItem: {},
      zfbDV: false,
      coin: 0,
      shopName: '',
      bindPhoneDV: false,
      obj: {
        pageNo: 1,
        pageSize: 30,
        level1CategoryName: '',
        level2CategoryName: '',
        searchData: 'All',
        orderNo: '',
        brandFlag: 'all'
      },
      selectItem: {},
      exchangeList: [],
      giveIndex: 1,
      checked: true,
      rechargeProtocolDV: false,
      giveMember: 0,
      giveNum: 0
    }
  },
  computed: {
    getPrice() {
      // 100×0.15×6.65（1积分=0.15美元）
      // const { rate } = this.exchangeList
      // const rate = this.exchangeList.filter(item => item.currency == 'USD')[0].rate
      // return `${this.selectItem.amount}×${rate}×6.65（1积分=${rate}美元）`
      return `充值金额=1积分≈0.99元人民币`
    }
  },
  watch: {},
  created() {
    this.currentExchange()
  },
  methods: {
    // 获取套餐信息
    detailList() {
      detailList({
        productIds: 1
      }).then(res => {
        this.dynamicTags = res.data
        const price = this.exchangeList.filter(item => item.currency == 'CNY')[0].rate *
          this.dynamicTags[0].amount
        // this.price = Number(price.toFixed(2))
        this.price = parseInt(Number(price))
        this.coin = this.dynamicTags[0].actuallyArrived
        this.shopName = this.dynamicTags[0].name
        this.loading = false
        this.selectItem = this.dynamicTags[0]
      })
    },
    // 获取用户信息
    userInfo() {
      userInfo().then(res => {
        this.user = res.data
        this.user.coinNum = res.data.coinNum + res.data.giftCoinNum
      })
    },
    // 获取金币余额
    queryCoin() {
      queryCoin().then(res => {
        this.user.coinNum = res.data.coinNum + res.data.giftCoinNum
      })
    },
    // 选择充值金币
    tapTag(item, index) {
      const price = this.exchangeList.filter(item => item.currency == 'CNY')[0].rate *
        item.amount
      // this.price = Number(price.toFixed(2))
      this.price = parseInt(Number(price))
      this.goldIndex = index
      this.coin = item.actuallyArrived
      this.shopName = item.name
      this.selectItem = item
    },
    // 选择支付方式
    tapPay(index) {
      this.payIndex = index
      this.payParams.payMethod = index
    },
    // 充值
    async tapToUp() {
      if (!this.checked) {
        return this.$message.error('请先勾选充值使用协议')
      }
      let result = await queryCoin()
      if (result.success) {
        if (!result.data.hasBindMobile) {
          this.bindPhoneDV = true
          return false
        }
      }
      if (this.goldIndex !== 3) {
        this.payParams.coinNum = 0
      } else {
        this.payParams.coinNum = this.dynamicTags[this.goldIndex].coinNum
      }
      this.payParams.detailCode = this.dynamicTags[this.goldIndex].detailCode
      createCoinOrder(this.payParams).then(res => {
        if (res.data.type === '1') {
          // 微信
          this.toUpDV = true
          this.qrCodeUrl = res.data.content
          this.creatQrCode()
          this.timeId = setInterval(() => {
            this.paymentStatus(res.data.orderNo)
          }, 3000)
        } else {
          // 支付宝
          let divForm = document.getElementsByTagName('divform')
          if (divForm.length) document.body.removeChild(divForm[0])
          const div = document.createElement('divform')
          div.innerHTML = res.data.content
          document.body.appendChild(div)
          document.forms[0].setAttribute('target', '_blank')
          document.forms[0].submit()
          this.zfbDV = true
        }
      })
    },
    // 查询微信支付
    paymentStatus(orderNo) {
      paymentStatus({
        orderNo
      }).then(res => {
        if (res.success && res.data) {
          this.closeToUpDv()
          this.queryCoin()
          this.$message.success('支付成功')
        }
      })
    },
    // 关闭微信充值弹窗
    closeToUpDv() {
      this.toUpDV = false
      this.timeId && clearInterval(this.timeId)
    },
    // 关闭支付宝弹窗
    closeZFBDV(val) {
      this.zfbDV = false
      if (val === 1) this.queryCoin()
    },
    // 创建支付二维码
    creatQrCode() {
      this.$nextTick(() => {
        this.$refs.qrCodeUrl.innerHTML = ''
        new QRCode(this.$refs.qrCodeUrl, {
          text: this.qrCodeUrl, // 需要转换为二维码的内容
          width: 240,
          height: 240,
          colorDark: '#000000',
          colorLight: '#ffffff',
          correctLevel: QRCode.CorrectLevel.H
        })
      })
    },
    handleBindPhone(val) {
      this.bindPhoneDV = false
      if (val === 1) {
        this.tapToUp()
      }
    },
    async currentExchange() {
      this.loading = true
      let res = await currentExchange()
      if (res.success) {
        this.exchangeList = res.data
        this.detailList()
        this.userInfo()
      }
    },
    handleGiveIndex(index) {
      this.giveIndex = index
      this.payParams.firstGift = index == 0 ? 'member' : 'search'
    },
    closeRechargeProtocol() {
      this.rechargeProtocolDV = false
    }
  }
}
</script>

<style scoped lang="scss">
.recharge-page {
  width: 1008px;
  height: 100%;
  padding: 20px;
  box-shadow: 0px 2px 12px 0px #edecf6;
  border-radius: 4px;

  .recharge-container {
    height: 100%;
    overflow-y: auto;
    padding: 30px;
    border: 1px solid #eceff5;
  }

  .item-list {
    display: flex;
    margin-bottom: 20px;

    .left-label {
      width: 155px;
    }

    .center {
      line-height: 47px;
    }

    .right-content {
      display: flex;

      .right-item {
        position: relative;
        margin-right: 20px;
        color: #373e4f;
        font-size: 14px;
        margin-top: 3px;

        .gold {
          color: #ffa200;
          font-weight: 700;
          font-size: 20px;
        }

        .gold-num {
          position: absolute;
          bottom: -4px;
          left: -7px;
          font-size: 24px;
          color: #ff455b;
          width: 480px;

          .gold-exchange {
            margin-left: 20px;
            font-size: 14px;
            font-weight: 400;
            color: #767d8f;
          }
        }

        .coin {
          position: absolute;
          bottom: -3px;
          left: -4px;
          width: 360px;
          font-weight: 400;
          color: #24232f;
          font-size: 20px;
        }

        .icon {
          display: inline-block;
          width: 20px;
          height: 20px;
          margin-right: 8px;
          margin-top: -5px;
          vertical-align: middle;
        }

        .icon-wx {
          background: url('../../assets/use-account/wx-pay.png') no-repeat;
          background-size: 100% 100%;
        }

        /* .icon-zfb {
          background: url('../../assets/use-account/zfb-pay.png') no-repeat;
          background-size: 100% 100%;
        } */
      }

      .date {
        display: flex;
        align-items: center;
        font-size: 16px;

        span {
          margin-left: 28px;
          margin-top: -4px;
        }
      }

      .font {
        font-size: 16px;
      }

      .red {
        color: #ff455b;
      }
    }
  }

  .item-list:nth-child(1),
  .item-list:nth-child(2) {
    align-items: center;

    .right-item {
      margin-top: 0;
    }
  }

  .item-list.item-list-felx {
    .right-content {
      flex-direction: column;
      justify-content: center;

      .right-item {
        margin-right: 20px;
        margin-bottom: 20px;
      }

      .integral {
        display: flex;
      }

      .give-welfare {
        display: flex;

        /* margin-top: 40px; */
        >div {
          position: relative;
          width: 200px;
          height: 50px;
          border-radius: 4px;
          text-align: center;
          line-height: 50px;
          font-size: 20px;
          font-weight: 400;
          color: #ff634e;
          border-top-left-radius: 7px;
          border: 1px solid transparent;
        }

        .left-give {
          margin-right: 20px;
        }

        .active-give {
          border: 1px solid #ff634e;
        }

        .the-first {
          background: #fff2e6;
          // background: #fff2e6 url('../../assets/use-account/the-first.png')
          //   no-repeat;
          // background-size: 50px 38px;
        }

        .active-bottom {
          position: absolute;
          bottom: 0;
          right: -1px;
          width: 20px;
          height: 20px;
          background: url('../../assets/use-account/active-bottom.png') no-repeat;
          background-size: 100% 100%;
        }
      }
    }
  }

  .gold-tag {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 200px;
    height: 50px;
    padding: 0;
    border: 1px solid #a3aab7;
    background-color: #fff;
    font-size: 20px;
    color: #373e4f;
    font-weight: 400;
    text-align: center;
    border-radius: 4px;
    cursor: pointer;

    div:nth-child(1) {
      font-size: 20px;
    }

    div:nth-child(2) {
      font-size: 16px;
      color: #ff455b;
    }
  }

  .gold-tag-active {
    width: 200px;
    height: 50px;
    border-color: #0668f6;
    /*
    background: url('../../assets/use-account/active-pay.png') no-repeat;
    background-size: 100% 100%;
     */
    position: relative;

    &:after {
      content: '';
      display: block;
      position: absolute;
      bottom: -1px;
      right: -1px;
      width: 24px;
      height: 24px;
      background: url('../../assets/icons/icon-hook-bottom-blue.png') no-repeat;
      background-size: 100% 100%;
    }
  }

  .pay-tag {
    width: 200px;
    height: 50px;
    margin-top: -2px;
    margin-left: -4px;
  }

  .agreement {
    font-size: 14px;
    font-weight: 400;
    color: #24232f;

    span {
      color: #0668f6;
      cursor: pointer;
    }
  }

  .footer-btn {
    margin-top: 30px;

    .el-button {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 300px;
      height: 50px;
      margin: 0 auto;
      color: #fff;
      font-size: 16px;
      background: linear-gradient(-64deg, #2a5fff, #4b80ff);
      border-radius: 25px;
    }
  }
}

.to-up-content {
  display: flex;
  justify-content: space-around;

  .left-code {
    width: 240px;

    .pay-tip {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #373e4f;
      font-size: 20px;
      margin-bottom: 30px;

      img {
        width: 27px;
        height: 27px;
        margin-right: 8px;
      }
    }

    .wx-pay-price {
      margin-top: 25px;

      div {
        font-size: 14px;
        margin-bottom: 18px;

        span:nth-child(1) {
          display: inline-block;
          width: 56px;
          color: #a3aab7;
          margin-right: 16px;
        }

        span:nth-child(2) {
          color: #373e4f;
        }
      }

      div:nth-child(2) {
        margin-bottom: 12px;
      }

      .pay-price {
        display: flex;
        align-items: center;

        .price {
          font-size: 30px;
          color: #ff455b;
          margin-left: -5px;
        }
      }
    }
  }

  .right-tip {
    width: 230px;
    height: 415px;

    img {
      width: 100%;
      height: 100%;
    }
  }
}

.dialog-footer {
  display: flex;
  justify-content: center;
  margin-top: -15px;

  span {
    cursor: pointer;
    color: #1772f7;
    font-size: 20px;
  }
}

.zfb-DV {
  ::v-deep.el-dialog {
    .el-dialog__header {
      padding: 0;
      overflow: hidden;
    }

    .zfb-title {
      height: 38px;
      line-height: 38px;
      padding-left: 20px;
      color: #fff;
      background: linear-gradient(#3599d6, #1779bf);
    }

    .zfb-content {
      display: flex;
      align-items: center;

      .left-img {
        color: #59aa00;
        font-size: 48px;
      }

      .right-tip {
        margin-left: 28px;
        color: #7b7b7b;
        font-size: 16px;
      }
    }

    .dialog-footer {
      .pay-issue {
        background-color: #edebeb;
        color: #333333;
        margin-right: 22px;
      }

      .pay-success {
        background-color: #ff8000;
        color: #fff;
        border: 1px solid #ff8000;
      }
    }
  }
}
</style>
